// ════════════════════════════════════════════════════════════════════════════
// M2.7 Madurez de Procesos — timeline del nivel global por tipoEjercicio (0735)
// Una serie por tipo de ejercicio (nunca mezcla contextos). Desde la lista de
// evaluaciones (nivelGlobal BPMM sobre fechaEvaluacion). Espejo de MadurezTimeline.
// ════════════════════════════════════════════════════════════════════════════
import {
  ResponsiveContainer,
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
} from 'recharts';
import type { EvaluacionBpmm, NivelBpmm, TipoEjercicioBpmm } from '../api-madurez-proceso';

const NIVEL_NUM: Record<NivelBpmm, number> = { N1: 1, N2: 2, N3: 3, N4: 4, N5: 5 };
const TIPO_COLOR: Record<TipoEjercicioBpmm, string> = {
  DIAGNOSTICO_INICIAL: '#1F3864',
  EVALUACION_PERIODICA: '#33BCE1',
  POST_TRANSFORMACION: '#2F5496',
  AUDITORIA_EXTERNA: '#E0A800',
};
const GO = '#595959';
const GM = '#D9D9D9';

interface Props {
  evaluaciones: EvaluacionBpmm[];
  emptyLabel: string;
}

type ConNivel = EvaluacionBpmm & { nivelGlobal: NivelBpmm };

export function MadurezProcesoTimeline({ evaluaciones, emptyLabel }: Props) {
  const conNivel = evaluaciones.filter((e): e is ConNivel => e.nivelGlobal != null);

  if (conNivel.length === 0) {
    return (
      <div
        style={{
          flex: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: GO,
          fontStyle: 'italic',
          fontSize: 11,
          minHeight: 120,
        }}
      >
        {emptyLabel}
      </div>
    );
  }

  const tipos = [...new Set(conNivel.map((e) => e.tipoEjercicio))];
  const data = conNivel
    .slice()
    .sort((a, b) => a.fechaEvaluacion.localeCompare(b.fechaEvaluacion))
    .map((e) => ({
      fecha: new Date(e.fechaEvaluacion).toLocaleDateString(),
      [e.tipoEjercicio]: NIVEL_NUM[e.nivelGlobal],
    }));

  return (
    <div style={{ flex: 1, minHeight: 160 }}>
      <ResponsiveContainer width="100%" height="100%">
        <LineChart data={data} margin={{ top: 8, right: 16, left: -8, bottom: 4 }}>
          <CartesianGrid strokeDasharray="3 3" stroke={GM} />
          <XAxis dataKey="fecha" tick={{ fontSize: 9, fill: GO }} />
          <YAxis domain={[0, 5]} tickCount={6} tick={{ fontSize: 9, fill: GO }} />
          <Tooltip contentStyle={{ fontSize: 11, fontFamily: "'DM Sans',sans-serif" }} />
          {tipos.map((tipo) => (
            <Line
              key={tipo}
              type="monotone"
              dataKey={tipo}
              name={tipo.replace(/_/g, ' ')}
              stroke={TIPO_COLOR[tipo]}
              strokeWidth={2}
              connectNulls
              dot={{ r: 3 }}
              isAnimationActive={false}
            />
          ))}
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}
